$( document ).ready(function() {
    function swiperCarousel(){
        const swiper = new Swiper('.c-hotel-gallery__main', {
            // Optional parameters
            centeredSlides: true,
            loop: true,
            slidesPerView: '1',
            spaceBetween: 30,
            grabCursor: true,
            //Breakpoint
            breakpoints: {
                // when window width is >= 320px
                320: {
                    spaceBetween: 8,
                },
                // when window width is >= 480px
                899: {
                    slidesPerView: '1',
                    spaceBetween: 40,
                }
            },
            // Pagination progressbar
            pagination: {
                el: '.c-hotel-gallery__progress',
                type: 'progressbar',
            },
            // Navigation arrows
            navigation: {
                nextEl: '.c-hotel-gallery__button-next',
                prevEl: '.c-hotel-gallery__button-prev',
            }
        });
    }
    swiperCarousel();
});